import { RouteConfig } from "vue-router";

export const REmployerServicesInviteCandidate: RouteConfig = {
  path: "invite",
  component: () =>
    import(
      /* webpackChunkName: "employer-services-candidates" */
      "./VEmployerServicesInviteCandidate.vue"
    ),
  meta: {
    title: "Select a candidate for the new visa application",
  },
};
